import styled from 'styled-components';
import { Card } from 'react-bootstrap';

const StyledMessage = styled(Card)`
  padding: 0.4rem;
  background-color: #ffffe633;
`;

export default StyledMessage;
